<template>
  <div>
    <modal :id="modalId" size="md">
      <div class="add-publishing" v-if="!del">
        <span class="close-icon" @click="hideModal">
          <img :src="closeSVG" />
        </span>
        <h3>{{ formAdd ? "Create" : "Edit" }} App Profile</h3>
        <div class="h-18"></div>
        <b-tabs content-class="mt-3">
          <b-tab title="Basic Info" active>
            <template>
              <b-form-group>
                <label>
                  Name <span style="color:#e03434">*</span>
                  <span id="pub-title">
              <img :src="tooltipSVG" />
            </span>
                  <b-tooltip target="pub-title" :title="pubTitleTip" />
                </label>
                <b-form-input
                    type="text"
                    required
                    v-model="publishing.title"
                    placeholder="Awesome App"
                    :disabled="!canEditPrimary"
                />
              </b-form-group>
              <b-form-group>
                <label>
                  Tagline <small style="color: #b0b1b2"><i>optional</i></small
                >&nbsp;
                  <span id="pub-subtitle">
              <img :src="tooltipSVG" />
            </span>
                </label>
                <b-tooltip target="pub-subtitle" :title="pubSubTitleTip" />
                <b-form-input
                    type="text"
                    required
                    v-model="publishing.subtitle"
                    placeholder="Transforming healthcare, one user at a time"
                    :disabled="
              activePublishingStatus == 'active' ||
                activePublishingStatus == 'inactive' ||
                activePublishingStatus == 'submitted'
            "
                ></b-form-input>
              </b-form-group>
              <!--- DESCRIPTION  -->
              <b-form-group>
                <label>
                  Description
                  <span id="pub-description">
              <img :src="tooltipSVG" />
            </span>
                  <b-tooltip target="pub-description" :title="pubDescriptionTip" />
                </label>
                <transition name="fadeHeight" mode="out-in">
                  <Editor
                      id="textarea-default"
                      v-show="true"
                      @input="input"
                      :clear="clear"
                      :content="publishing.description"
                      @resetClear="resetClear"
                  />
                </transition>
              </b-form-group>
              <!---- PUBLISHER ---->
              <!--- Not sure if this is needed -->
              <!-- Maybe if publishing on behalf of someone -->
              <b-form-group>
                <label>
                  Publisher
                  <small style="color: #b0b1b2"><i>optional</i></small> &nbsp;
                  <span id="pub-publisher">
              <img :src="tooltipSVG" />
            </span>
                  <b-tooltip target="pub-publisher" :title="pubPublisherTip" />
                </label>
                <b-form-input
                    type="text"
                    required
                    v-model="publishing.publisher"
                    placeholder="Enter your publisher here"
                />
              </b-form-group>
            </template>
          </b-tab>
          <b-tab title="Details">
            <template >
            <!---- PUBLISHER ---->
            <!--- Not sure if this is needed -->
            <!-- Maybe if publishing on behalf of someone -->
            <b-form-group
                v-if="false"
            >
              <label>
                Publisher
                <small style="color: #b0b1b2"><i>optional</i></small> &nbsp;
                <span id="pub-publisher">
              <img :src="tooltipSVG" />
            </span>
                <b-tooltip target="pub-publisher" :title="pubPublisherTip" />
              </label>
              <b-form-input
                  type="text"
                  required
                  v-model="publishing.publisher"
                  placeholder="Enter your publisher here"
              />
            </b-form-group>

            <!---- DUNS ---->
            <b-form-group>
              <label>
                D-U-N-S Number
                <span id="pub-duns">
              <img :src="tooltipSVG" />
            </span>
                <b-tooltip target="pub-duns" :title="pubISBNTip" />
              </label>
              <b-form-input
                  type="text"
                  required
                  v-model="publishing.duns"
                  placeholder="123 123 123 123"
              />
            </b-form-group>

            <!-- CREW -->
            <!--ROW 1 -->
            <b-form-row class="half-fields">
              <b-col>
                <!--- LANGUAGE -->
                <!--- TODO Support localization -->
                <b-form-group
                    label="Primary Language"
                    description="The primary language used in your your app."
                    label-for="input-6"
                    class="custom-label"
                >
                  <vue-bootstrap-typeahead
                      id="languagePrimary"
                      ref="languagePrimary"
                      v-model="publishing.languagePrimary"
                      no-resize
                      :data="$typeAheadAboutsLanguage"
                      placeholder="Mandarin"
                      :serializer="s => `${s.text}`"
                      @hit="$event => (primaryLanguage = $event.text)"
                  />
                </b-form-group>
              </b-col>
              <b-col>
                <b-form-group>
                  <label>
                    Pages
                    <span id="pub-pages">
                  <img :src="tooltipSVG" />
                </span>
                  </label>
                  <b-form-input
                      type="number"
                      required
                      v-model.number="publishing.pages"
                      placeholder="Number of pages"
                      :disabled="!canEditSecondary"
                  />
                </b-form-group>
              </b-col>
            </b-form-row>

            <!--ROW 2 -->
            <b-form-row class="half-fields">
              <b-col>
                <b-form-group>
                  <label>
                    Category
                    <span id="pub-category">
                  <img
                      :src="tooltipSVG"
                      v-b-tooltip.hover.html="pubCategoryTip"
                  />
                </span>
                  </label>
                  <b-form-select
                      v-model="publishing.category"
                      :options="languagesArray"
                  />
                </b-form-group>
              </b-col>
              <b-col>
                <b-form-group>
                  <label>
                    Series
                    <span id="pub-series">
                  <img :src="tooltipSVG" />
                </span>
                  </label>
                  <b-form-input
                      type="number"
                      required
                      v-model.number="publishing.series"
                      placeholder="Add series"
                      :disabled="!canEditSecondary"
                  />
                </b-form-group>
              </b-col>
            </b-form-row>

            <!-- ROW 3 -->
            <b-form-row class="half-fields">
              <b-col>
                <b-form-group>
                  <label>
                    Price $
                    <span id="pub-price">
                  <img :src="tooltipSVG" />
                </span>
                  </label>
                  <b-form-input
                      type="number"
                      required
                      v-model.number="publishing.price"
                      placeholder="Add price of activation publishing"
                      :disabled="!canEditSecondary"
                  />
                </b-form-group>
              </b-col>
              <b-col>
                <b-form-group>
                  <label>
                    Reviews
                    <span id="pub-reviews">
                  <img :src="tooltipSVG" />
                </span>
                  </label>
                  <b-form-input
                      type="text"
                      required
                      v-model="publishing.reviews"
                      placeholder="How many reviews?"
                      :disabled="!canEditSecondary"
                  />
                </b-form-group>
              </b-col>
            </b-form-row>
          </template>
          </b-tab>
          <b-tab title="Crew">
            <template>
              <div class="crew">
                <div>
                  <h6>Crew:</h6>
                  <div class="ico" @click="showCrew" v-if="canEditSecondary">
                    <svg
                        width="28"
                        height="28"
                        viewBox="0 0 28 28"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                    >
                      <circle
                          cx="14"
                          cy="14"
                          r="14"
                          fill="var(--theme-color)"
                          fill-opacity="0.1"
                      />
                      <path
                          d="M14 6V22"
                          stroke="var(--theme-color)"
                          stroke-width="2"
                          stroke-linecap="round"
                      />
                      <path
                          d="M6 14L22 14"
                          stroke="var(--theme-color)"
                          stroke-width="2"
                          stroke-linecap="round"
                      />
                    </svg>
                  </div>
                  <div class="engine" v-for="(crew, n) in publishing.crew" :key="n">
                    {{ crew.nickname }}
                    <svg
                        v-b-tooltip.hover
                        title="Remove Crew"
                        @click="removeCrew(n)"
                        width="10"
                        height="10"
                        viewBox="0 0 10 10"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                          d="M1 1L9 9"
                          stroke="var(--theme-color)"
                          stroke-width="1.5"
                          stroke-linecap="round"
                      />
                      <path
                          d="M9 1L1 9"
                          stroke="var(--theme-color)"
                          stroke-width="1.5"
                          stroke-linecap="round"
                      />
                    </svg>
                  </div>
                </div>
              </div>
            </template>
          </b-tab>
          <b-tab title="Release">
            <template>
              <!-- ROW 3 -->
              <b-form-row class="half-fields">
                <b-col>
                  <b-form-group>
                    <label>
                      Version Number
                      <span id="pub-version-num">
                </span>
                    </label>
                    <b-form-input
                        type="number"
                        required
                        v-model.number="publishing.series"
                        placeholder="Add ediion"
                        :disabled="!canEditSecondary"
                    />
                  </b-form-group>
                </b-col>
                <b-col>
                  <b-form-group>
                    <label>
                      Edition No.
                      <span id="pub-edition-num">
                  <img :src="tooltipSVG" />
                </span>
                    </label>
                    <b-form-input
                        type="number"
                        required
                        v-model.number="publishing.editionNum"
                        placeholder="Add series"
                        :disabled="!canEditSecondary"
                    />
                  </b-form-group>
                </b-col>
              </b-form-row>

              <!-- ROW 4 -->
              <b-form-row >
                <b-col>
                  <b-form-group>
                    <label>
                      Copyright
                      <span id="pub-copyright">
                  <img :src="tooltipSVG" />
                </span>
                    </label>
                    <b-form-input
                        type="text"
                        required
                        v-model.number="publishing.copyright"
                        placeholder="Add copyright"
                        :disabled="!canEditSecondary"
                    />
                  </b-form-group>
                </b-col>
              </b-form-row>
              <div class="resources">
                <div>
                  <h6>Resources:</h6>
                  <div
                      class="ico"
                      @click="handleResouceBlocksClick"
                      v-if="canEditSecondary"
                  >
                    <svg
                        width="28"
                        height="28"
                        viewBox="0 0 28 28"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                    >
                      <circle
                          cx="14"
                          cy="14"
                          r="14"
                          fill="var(--theme-color)"
                          fill-opacity="0.1"
                      />
                      <path
                          d="M14 6V22"
                          stroke="var(--theme-color)"
                          stroke-width="2"
                          stroke-linecap="round"
                      />
                      <path
                          d="M6 14L22 14"
                          stroke="var(--theme-color)"
                          stroke-width="2"
                          stroke-linecap="round"
                      />
                    </svg>
                  </div>
                  <img
                      v-for="(resource, i) in publishing.tools"
                      :src="resource.imgURL"
                      :key="i"
                      :alt="resource.name"
                      v-b-tooltip.hover
                      :title="resource.name"
                      width="30"
                  />
                </div>
              </div>
            </template>
          </b-tab>
          <b-tab title="Marketing">
            <template>
              <!-- ROW 3 -->
              <b-form-row class="half-fields">
                <b-col>
                  <b-form-group>
                    <label>
                      Price $
                      <span id="pub-price">
                  <img :src="tooltipSVG" />
                </span>
                    </label>
                    <b-form-input
                        type="number"
                        required
                        v-model.number="publishing.price"
                        placeholder="Add price of activation publishing"
                        :disabled="!canEditSecondary"
                    />
                  </b-form-group>
                </b-col>
                <b-col>
                  <b-form-group>
                    <label>
                      Reviews
                      <span id="pub-reviews">
                  <img :src="tooltipSVG" />
                </span>
                    </label>
                    <b-form-input
                        type="text"
                        required
                        v-model="publishing.reviews"
                        placeholder="How many reviews?"
                        :disabled="!canEditSecondary"
                    />
                  </b-form-group>
                </b-col>
              </b-form-row>

              <b-form-group v-if="true" label="SEO">
                <vue-taggable-select
                    placeholder="Enter SEO Tags"
                    v-model="publishing.seo"
                    :taggable="true"
                    :options="languagesArray"
                    ref="seo"
                />
              </b-form-group>
              <div class="form-group">
                <div class="places-lived">
                  <div
                      class="place__places-lived"
                      v-for="(seo, index) in publishing.seo"
                      :key="index"
                  >
                    {{ seo }}
                    <span class="ico del__ico" @click="delTag(seo)">
                <svg
                    width="12"
                    height="12"
                    viewBox="0 0 12 12"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                      fill-rule="evenodd"
                      clip-rule="evenodd"
                      d="M1 3C1 2.72386 1.22386 2.5 1.5 2.5H10.5C10.7761 2.5 11 2.72386 11 3C11 3.27614 10.7761 3.5 10.5 3.5H1.5C1.22386 3.5 1 3.27614 1 3Z"
                      fill="#FF8C7D"
                  />
                  <path
                      fill-rule="evenodd"
                      clip-rule="evenodd"
                      d="M5 1.5C4.86739 1.5 4.74022 1.55268 4.64645 1.64645C4.55268 1.74021 4.5 1.86739 4.5 2V2.5H7.5V2C7.5 1.86739 7.44732 1.74021 7.35355 1.64645C7.25979 1.55268 7.13261 1.5 7 1.5H5ZM8.5 2.5V2C8.5 1.60217 8.34196 1.22064 8.06066 0.93934C7.77936 0.658035 7.39782 0.5 7 0.5H5C4.60218 0.5 4.22064 0.658035 3.93934 0.93934C3.65804 1.22064 3.5 1.60217 3.5 2V2.5H2.5C2.22386 2.5 2 2.72386 2 3V10C2 10.3978 2.15804 10.7794 2.43934 11.0607C2.72064 11.342 3.10217 11.5 3.5 11.5H8.5C8.89783 11.5 9.27936 11.342 9.56066 11.0607C9.84196 10.7794 10 10.3978 10 10V3C10 2.72386 9.77614 2.5 9.5 2.5H8.5ZM3 3.5V10C3 10.1326 3.05268 10.2598 3.14645 10.3536C3.24021 10.4473 3.36739 10.5 3.5 10.5H8.5C8.63261 10.5 8.75978 10.4473 8.85355 10.3536C8.94732 10.2598 9 10.1326 9 10V3.5H3Z"
                      fill="#FF8C7D"
                  />
                  <path
                      fill-rule="evenodd"
                      clip-rule="evenodd"
                      d="M5 5C5.27614 5 5.5 5.22386 5.5 5.5V8.5C5.5 8.77614 5.27614 9 5 9C4.72386 9 4.5 8.77614 4.5 8.5V5.5C4.5 5.22386 4.72386 5 5 5Z"
                      fill="#FF8C7D"
                  />
                  <path
                      fill-rule="evenodd"
                      clip-rule="evenodd"
                      d="M7 5C7.27614 5 7.5 5.22386 7.5 5.5V8.5C7.5 8.77614 7.27614 9 7 9C6.72386 9 6.5 8.77614 6.5 8.5V5.5C6.5 5.22386 6.72386 5 7 5Z"
                      fill="#FF8C7D"
                  />
                </svg>
              </span>
                  </div>
                </div>
              </div>
              <div class="social">
                <div>
                  <h6>Social:</h6>
                  <div class="ico" @click="handleSocialClick" v-if="canEditSecondary">
                    <svg
                        width="28"
                        height="28"
                        viewBox="0 0 28 28"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                    >
                      <circle
                          cx="14"
                          cy="14"
                          r="14"
                          fill="var(--theme-color)"
                          fill-opacity="0.1"
                      />
                      <path
                          d="M14 6V22"
                          stroke="var(--theme-color)"
                          stroke-width="2"
                          stroke-linecap="round"
                      />
                      <path
                          d="M6 14L22 14"
                          stroke="var(--theme-color)"
                          stroke-width="2"
                          stroke-linecap="round"
                      />
                    </svg>
                  </div>
                  <img
                      v-for="(social, i) in publishing.socials"
                      :src="getSvg(social.type)"
                      :key="i"
                      :alt="social.profileName"
                      v-b-tooltip.hover
                      :title="social.profileName"
                      width="30"
                  />
                </div>
              </div>
            </template>
          </b-tab>
          <b-tab title="About">
            <template v-if="publishing.about_intro">
              <!--Tutorial Video -->
              <hr/>
              <label>Policies</label>
              <!----POLICIES --->
              <b-form-group
                  description="Enter the URL of the page with your terns abd conditions"
              >
                <b-form-input
                    type="text"
                    v-model="publishing.about_intro.policy.terms"
                    placeholder="Terms and Conditions"
                />
              </b-form-group>
            </template>
          </b-tab>
        </b-tabs>
        <div class="foot">
          <div class="d-flex justify-content-between">
            <b-button
              style="width: 100%;"
              variant="primary"
              v-if="formAdd"
              @click="handleAddPublishingButtonClick"
              :disabled="!canAdd"
            >
              Add
            </b-button>
            <b-button
              style="width:100%"
              variant="primary"
              @click="handleUpdatePublishingClick"
              v-else
              :disabled="!canUpdate"
            >
              Update
            </b-button>
          </div>
        </div>
      </div>
      <div class="add-publishing del-publishing" v-else>
        <span class="close-icon" @click="$bvModal.hide(publishingModal)">
          <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <circle cx="12" cy="12" r="12" fill="#E4E6EB" />
            <g clip-path="url(#clip0)">
              <path
                d="M12.5891 12.0006L17.2111 7.37855C17.3739 7.21582 17.3739 6.95199 17.2111 6.78928C17.0484 6.62657 16.7846 6.62655 16.6219 6.78928L11.9998 11.4113L7.37782 6.78928C7.21509 6.62655 6.95126 6.62655 6.78855 6.78928C6.62584 6.95201 6.62582 7.21584 6.78855 7.37855L11.4106 12.0006L6.78855 16.6226C6.62582 16.7853 6.62582 17.0492 6.78855 17.2119C6.8699 17.2932 6.97655 17.3339 7.0832 17.3339C7.18984 17.3339 7.29647 17.2932 7.37784 17.2119L11.9998 12.5899L16.6218 17.2119C16.7032 17.2932 16.8098 17.3339 16.9165 17.3339C17.0231 17.3339 17.1298 17.2932 17.2111 17.2119C17.3739 17.0491 17.3739 16.7853 17.2111 16.6226L12.5891 12.0006Z"
                fill="#606770"
              />
            </g>
            <defs>
              <clipPath id="clip0">
                <rect
                  width="10.6667"
                  height="10.6667"
                  fill="white"
                  transform="translate(6.6665 6.66675)"
                />
              </clipPath>
            </defs>
          </svg>
        </span>
        <h3>Delete Publishing</h3>
        <div class="warning-msg">
          <p>
            Are you sure want to delete
            <strong>{{ publishings[this.activeIndex].title }}</strong>
            publishing?
          </p>
        </div>
        <div class="d-flex justify-content-between">
          <b-button class="danger btn-round-fill" @click="deletePublishing">
            Yes! Delete
          </b-button>
          <b-button class="btn-simple" @click="hideDeletePublishing">
            No! back
          </b-button>
        </div>
      </div>
    </modal>
    <resources-store
      :modal-id="modalIdResourcesBlocks"
      @updateResources="updateResources($event)"
    />
    <crew
      @updateCrew="updateCrew"
      :key="refresh + 1"
      :modal-id="modalIdCrewBlocks"
      :oldCrew="crew"
      :addedCrew="addedCrew"
      :profile="profile"
    />
    <social
      :modal-id="modalIdSocialsClick"
      :links="publishing.socials"
      @handleAddSocialLink="handleAddSocialLink($event)"
    />
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import Modal from "@/components/common/modal";
import Editor from "@/components/common/editor";
import ResourcesStore from "./resourcesStore"; //TODOMake a component or bring in
import Crew from "./crew"; //TODOMake a component or bring in
import Social from "./social"; //TODOMake a component or bring in
import VueTaggableSelect from "../../../_shared/_multiselect/VueTaggableSelect"; //TODOMake a component or bring in
import { BIconLayoutTextSidebarReverse } from "bootstrap-vue";
import socialsMixin from "@/mixins/Socials";
import VueBootstrapTypeahead from "vue-bootstrap-typeahead";
export default {
  name: "AddEditPublishingModal",
  mixins: [socialsMixin],
  components: {
    Modal,
    Editor,
    VueTaggableSelect,
    ResourcesStore,
    Crew,
    Social,
    VueBootstrapTypeahead
  },
  props: {
    modalId: {
      type: String,
      default: null
    }
  },
  beforeMount() {},
  mounted() {
    this.$root.$on("bv::modal::hide", (bvEvent, modalId) => {
      modalId == "publishing-modal" ? this.cancelAction() : "";
    });
    this.fetching = false;
    this.setRolesArray();
    this.$store.dispatch("user/getListNames");
    this.$store.dispatch("user/getListRoles");
  },
  computed: {
    ...mapGetters({
      user: "user/user",
      publishings: "user/listPublishings",
      getLocalPublishingWithId: "user/getLocalPublishingWithId",
      profile: "user/profile"
    }),
    canEditPrimary() {
      return this.activePublishingStatus === "draft" || this.formAdd
        ? true
        : false;
    },
    canEditSecondary() {
      return this.activePublishingStatus !== "inactive" &&
        this.activePublishingStatus !== "submitted"
        ? true
        : false;
    },
    canAdd() {
      return this.publishing.title && this.publishing.title.trim().length > 0
        ? true
        : false;
    },
    canUpdate() {
      return this.publishing.title &&
        this.publishing.title.trim().length > 0 &&
        this.activePublishingStatus !== "inactive" &&
        this.activePublishingStatus !== "submitted"
        ? true
        : false;
    },
    currentPublishing() {
      return this.publishings && Array.isArray(this.publishings)
        ? this.publishings.filter(aPublishing => {
            return aPublishing.id === this.publishingId;
          })[0]
        : null;
    }
  },
  methods: {
    showAddPublishing() {
      this.del = false;
      this.formAdd = true;
      this.resetForm();
      this.$nextTick(function() {
        this.$bvModal.show(this.publishingModal);
      });
    },
    showEditPublishing(publishing) {
      this.del = false;
      this.formAdd = false;
      this.publishing = publishing;
      this.activePublishingStatus = publishing.status;
      //this.publishing.crew = publishing.crew;
      this.$nextTick(function() {
        this.$bvModal.show(this.publishingModal);
      });
    },
    handleAddPublishingButtonClick() {
      this.$emit("add-publishing", this.publishing);
    },
    handleUpdatePublishingClick() {
      this.$emit("update-publishing", this.publishing);
    },
    updateCrews(crew) {
      this.publishing.crew = crew.active;
      //this.addedCrew = crew.all;
      this.show.addCrew = false;
    },
    removeCrew(n) {
      console.log("remove crew => ", n, this.publishing.crew);
      this.publishing.crew.splice(n, 1);
      console.log("remove crew => ", n, this.publishing.crew);
      //  this.crew = this.publishing.crew;
    },
    handleSelectPublishingForManagement() {
      this.$store
        .dispatch("user/setSelectedPublishingId", this.selectedPublishing.id)
        .then(data => {
          console.log(`Publishing Id submitted`);
          console.log(data);
        })
        .catch(error => {
          this.$nprogress.done();
          this.$store.dispatch("user/showNotification", {
            title: error.code,
            description: error.message,
            variant: "danger"
          });
        })
        .finally(() => {
          this.fetching = false;
        });
    },
    setNameinDB(namesToSave) {
      let n = {};
      this.$store
        .dispatch("user/addNames", {
          names: namesToSave.length > 0 ? namesToSave : []
        })
        .then(async nameswUid => {
          console.log("nameswUid => ", nameswUid);
          await nameswUid.map((el, index) => {
            el._names_numbers_places_id = el.uid;
            delete el.uid;
            el.order = index;
            return el;
          });
          return nameswUid;
        });
    },
    setRolesArray() {
      this.$typeAheadRolesData.forEach(e => this.rolesArray.push(e.text));
    },
    resetClear() {
      this.clear = false;
    },
    input(val) {
      this.publishing.description = val.content;
    },
    inputAbout(val) {
      this.publishing.about_intro.about = val.content;
    },
    inputIntro(val) {
      this.publishing.about_intro.intro = val.content;
    },
    getStatus(status) {
      switch (status) {
        case "draft":
          return "Draft";
        case "submitted":
          return "Submitted";
        case "need_work":
          return "Needs Work";
        case "inactive":
          return "Removed";
        case "active":
          return "Published";
        default:
          return "Draft";
      }
    },
    getStatusColor(status) {
      if (status == "draft") {
        return "#C0C0C0";
      } else if (status == "submitted") {
        return "var(--theme-color)";
      } else if (status == "need_work") {
        return "#FFCC00";
      } else if (status == "inactive") {
        return "#FF0000";
      } else if (status == "active") {
        return "#4BB543";
      }
    },
    addTag() {
      if (this.seo && this.seo.trim() == "") return;
      this.publishing.seo.unshift(this.seo);
      this.seo = "";
    },
    delTag(tag) {
      let index = this.publishing.seo.indexOf(tag);
      if (index > -1) {
        this.publishing.seo.splice(index, 1);
      }
    },
    toggleSpheres(e) {
      if (this.publishing.spheres.includes(e)) {
        let index = this.publishing.spheres.indexOf(e);
        this.publishing.spheres.splice(index, 1);
      } else {
        this.publishing.spheres.push(e);
      }
    },
    hideModal() {
      this.$bvModal.hide(this.publishingModal);
    },
    cancelAction() {
      this.resetForm();
      this.refresh++;
    },
    resetForm() {
      this.publishing = {
        name: "",
        intro: null,
        about: null,
        tagline: null,
        about_intro: {
          about:[],
          intro:[],
          videoURLTutorial: null,
          credits:[],
          policy:{
            terms: null,
            privacy: null,
            data:null,
          },
        },
        title: "",
        subtitle: "",
        description: [],
        seo: [],
        spheres: [],
        tools: [],
        guides: [],
        connections: [],
        imgURL: "",
        roles: null,
        crew: [],
        socials: [],
        price: 0,
        category: "",
        languages: [],
        age: 3,
        leaningStyle: "",
        copyright: ""
      };
      this.seo = "";
      this.activeIndex = null;
      this.activePublishingStatus = null;
    },
    handleResouceBlocksClick() {
      this.$bvModal.show(this.modalIdResourcesBlocks);
    },
    updateResources(tools) {
      this.publishing.tools = tools;
    },
    handleAddSocialLink(socials) {
      this.publishing.socials = socials;
    },
    showCrew() {
      this.$bvModal.show(this.modalIdCrewBlocks);
    },
    handleSocialClick() {
      this.$bvModal.show(this.modalIdSocialsClick);
    },
    updateCrew(crew) {
      console.log("crew => ", this.publishing.crew);
      this.publishing.crew = crew.active;
      console.log("this.publishing => ", this.publishing);
      crew.active.forEach(e => {
        this.publishing.crew.push(e);
      });
      // Object.values(this.publishing.crew.reduce((acc,cur)=>Object.assign(acc,{[cur.email]:cur}),{}))
      //this.addedCrew = crew.all;
      this.$bvModal.hide(this.modalIdCrewBlocks);
    },
    getSvg(type) {
      let social = this.$socials.filter(social => social.type == type);
      return social[0] ? social[0].svg : "";
    }
  },
  data() {
    return {
      //Move tooltips to inputed data
      tooltipSVG: require("@/assets/svg/tooltip.svg"),
      closeSVG: require("@/assets/svg/close.svg"),
      formplusSVG: require("@/assets/svg/formplus.svg"),
      pubTitleTip:
          'Enter the main title as it appears on the cover and title page. The title should be the same on the paperback, hardcover, and ebook. Do not include any subtitle, series, edition, or format information in this field. For example: "Publishing 101: Everything You Need to Know", Publishing 101 is the title and Everything You Need to Know is the subtitle.',
      pubSubTitleTip:
          'A subtitle is often a descriptive or explanatory title. Enter the subtitle as it would appear on the cover or title page. Keep subtitles succinct so as not to lose a potential buyer\'s attention. For example: "Publishing 101: Everything You Need to Know," Publishing 101 is the title and Everything You Need to Know is the subtitle.',
      pubDescriptionTip:
          "Descriptive copy appropriate for public display, used for marketing, discovery, and sales purposes. This is your best chance to get people interested.\n" +
          ">Describe the work in straightforward and consumer-friendly terms.\n" +
          ">BOLDING key sentences can help your work stand out on certain websites.\n" +
          '>Use keywords in your book description that are listed in the "Keyword" field to help with discovery of your work.',
      pubPublisherTip:
          " This is lookup table for your publisher. Leave blank is self-published.",
      pubISBNTip:
          "An ISBN (International Standard Book Number), also known as EAN (European Article Number), is a unique thirteen-digit item code provided by your country's ISBN agency and assigned by publishers to identify the format and edition of a particular title, required by retailers and distributors for sales and inventory purposes. An ebook will have a different ISBN or EAN than the print version of the same book. Read more about ISBNs.",
      pubRightsTip:
          "Choose this option if your book is under copyright and you hold the necessary rights for the content being published.",
      pubDomainWork:
          "Select this option if you are publishing a public domain book. Keep in mind that the duration of copyright varies between countries/regions. So, if your book is in the public domain in one country/region but not another, you must identify your territory rights accordingly",
      pubDateTip:
          "Enter the date on which your book was first published. Leave this blank if you are publishing your book for the first time.",
      pubPagesTip: "test",
      pubAdultContent:
          "Does this book contain language, situations, or images inappropriate for children under 18 years of age?- Your publication date is the date on which your book was first published. You cannot change it after publishing your title. If you leave this blank, D3rriana will automatically use the date on which your book goes live (i.e. it is available for sale).",
      pubReviewsTip: "test",
      pubPriceTip: "test",
      pubSeriesTip:
          "Titles that feature an ongoing story, recurring character, or other organizing principle, such as theme or plot.",
      pubCategoryTip: " test",
      pubFormatTip: " test",
      pubCopyrightTip: " test",
      pubLanguageTip:
          "Choose your publishing's primary language (the language in which the book was written). <a href='/help/language-support'> Learn more about languages supported on D3rriana</a>.",
      pubDimensionsTip:
          "Choose your publishing's primary language (the language in which the book was written). <a href='/help/language-support'> Learn more about languages supported on D3rriana</a>.",

      pubResourceBlockTip: " test",
      pubCrewTip: "test",
      pubSocialTip: " test",
      pubSeriesNo: "",
      pubEditionNo:
          "An edition is a particular version of a book. The edition number tells readers whether the book is an original version or an updated version. If this is the first time you have published this book, enter the numeral 1. If the book was previously published and the version you are publishing contains significant changes, enter the numeral 2 (and so on).",
      pubSelectImprint: "",
      pubSubjects: "",
      pubKeywords: "",
      pubSummary: "",
      pubClaimCorner: "",
      pubThemeBGColorPrimary: "",
      pubThemeBGColorSecondary: "",
      modalIdResourcesBlocks: "block-resources",
      modalIdCrewBlocks: "block-crew",
      modalIdSocialsClick: "block-social",
      publishingModal: "publishing-modal",
      publishing: {
        title: null,
        subtitle: null,
        description: {},
        publisher: null,
        duns: null,
        format: "",
        pages: null,
        reviews: null,
        price: null,
        series: [],
        versionNum: null,
        editionNum: null,
        keywords: [],
        seo: [],
        tools: [],
        crew: [],
        socials: [],
        imgURL: null,
        roles: null,
        category: "",
        languagePrimary: null,
        languages: null,
        copyright: null,
        publishingRights: null,
        adultContent: null,
        showClaimCorner: null
      },
      crew: [],
      publishingId: null,
      selectedPublishing: {},
      selectedPublishingId: null,
      fetching: false,
      refresh: 1,
      formAdd: true,
      del: false,
      addedCrew: [],
      activeIndex: -1,
      activeCollapse: -1,
      clear: false,
      seo: "",
      asset: "",
      popupText: "Copy to clipboard",
      imgURL: "",
      rolesArray: [],
      languagesArray: this.$typeAheadAboutsLanguage,
      activePublishingStatus: null,
      activePublishing: null
    };
  },
};
</script>

<style lang="scss" scoped>
.publishing-foot {
  display: flex;
  justify-content: space-between;
  .stats {
    display: flex;
    align-items: center;
    .ico {
      margin: 0 17px;
    }
  }
  .collapse-foot {
    display: flex;
    justify-content: flex-end;
    .btn-simple-primary {
      background-color: #fff;
      font-style: normal;
      font-weight: 600;
      font-size: 14px;
      line-height: 19px;
      justify-content: center;
      padding: 8px 16px;
      border: none;
      display: flex;
      letter-spacing: 0.05em;
      align-items: center;
      color: var(--theme-color);
      margin-left: 16px;
      border-radius: 4px;
      transition: all 0.2s ease-in-out;
      svg {
        margin-right: 16px;
      }
      &:hover {
        background-color: #f3f6f9;
      }
      &.btn-start {
        background-color: #f3f6f9;
        &:hover {
          background-color: #dfdfdf;
          box-shadow: 0px 0px 4px 0px #eee;
        }
      }
    }
  }
}

.areas {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  margin-left: 25%;
  & > div {
    width: 60px;
    h6 {
      font-style: normal;
      font-weight: normal;
      font-size: 12px;
      line-height: 16px;
      color: #8d99a0;
    }
    svg {
      cursor: pointer;
    }
  }
}
.small-check {
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 19px;
  color: #8d99a0;
  margin-left: 24px;
}
.custom-control-label {
  font-style: normal;
  font-weight: normal;
  font-size: 16px;
  line-height: 22px;
  color: #474d52;
}
.bv-no-focus-ring {
  position: relative;
  .pre {
    position: absolute;
    left: 15px;
    top: 50%;
    transform: translateY(-50%);
    color: #8d99a0;
  }
  .post {
    position: absolute;
    right: 15px;
    top: 50%;
    color: #8d99a0;
    transform: translateY(-50%);
  }
  input {
    padding-left: 30px;
  }
}
.add-publishings {
  font-style: normal;
  font-weight: bold;
  font-size: 14px;
  line-height: 19px;
  color: var(--theme-color);
  cursor: pointer;
  position: relative;
}
.add-publishing {
  .foot {
    margin-top: 24px;
    border-top: 1px solid #dddddd;
    padding: 24px 0 10px 0;
  }
  .close-icon {
    position: absolute;
    top: 24px;
    right: 20px;
    cursor: pointer;
  }
  .btn-round-fill {
    max-width: 160px;
    width: 100%;
  }
  h3 {
    margin-bottom: 0;
    margin-top: 10px;
    font-style: normal;
    font-weight: 600;
    font-size: 24px;
    line-height: 33px;
    color: #474d52;
    text-align: center;
  }
}
.del-publishing {
  .warning-msg {
    margin: 24px 0;
    p {
      text-align: center;
      margin: 0;
    }
  }
  .btn-round-fill {
    background-color: #ef5c4a;
    border-color: #ef5c4a;
  }
  .btn-simple {
    color: #ef5c4a;
    font-weight: bold;
  }
}

.search {
  cursor: pointer;
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 19px;
  color: #8d99a0;
}
.card-guide {
  box-shadow: none;
}
.publishings {
  margin-top: 20px;
  .card {
    border: none;
    box-shadow: 0px 4px 12px rgba(0, 0, 0, 0.08);
    .details {
      display: flex;
      align-items: center;
      margin-bottom: 10px;
      & > div {
        margin-right: 18px;
        display: flex;
        align-items: center;
        svg {
          margin-right: 5px;
        }
      }
      .ico {
        margin: 0 17px;
        cursor: pointer;
      }
      .doc-ico {
        margin-left: 0;
      }
      .doc-link {
        color: var(--theme-color);
      }
    }
    .card-text {
      font-style: normal;
      font-weight: normal;
      font-size: 14px;
      line-height: 19px;
      display: flex;
      align-items: center;
      color: #474d52;
    }
    .status-btn {
      display: inline-block;
      margin-right: 15px;
      width: 105px;
      height: 21px;
      font-family: Nunito;
      font-style: normal;
      font-weight: normal;
      font-size: 14px;
      color: #ffffff;
      background: var(--theme-color);
      text-align: center;
      border: none;
      border-radius: 3px;
    }
  }

  .card-header {
    display: grid;
    grid-template-columns: 1fr 30px;
    align-items: center;
    padding: 0;
    .edit,
    .delete {
      display: none;
      cursor: pointer;
    }
    .btn-collapse {
      padding: 24px;
      text-align: left;
      box-shadow: none;
    }
    &.active {
      grid-template-columns: 1fr 30px 30px 30px;
      .edit,
      .delete {
        display: block;
      }
    }

    border: none;
    box-shadow: none;
    background: none;
  }
  .card-body {
    padding-top: 0;
    img {
      cursor: pointer;
      position: relative;
      // top: 50%;
      right: 4px;
      // -webkit-transform: translateY(-50%);
      // transform: translateY(-50%);
      height: 100px;
      width: 100px;
      display: -webkit-box;
      display: -ms-flexbox;
      display: flex;
      -webkit-box-align: center;
      -ms-flex-align: center;
      align-items: center;
      -webkit-box-pack: center;
      -ms-flex-pack: center;
      justify-content: center;
      background: rgba(85, 126, 251, 0.1);
      border-radius: 8px;
    }
    .publishing-description {
      left: 5px;
    }
  }
}
.places-lived {
  margin-top: 26px;
  .place__places-lived {
    font-style: normal;
    font-weight: normal;
    font-size: 14px;
    line-height: 19px;
    color: #474d52;
    margin: 6px 15px;
  }
  .del__ico {
    cursor: pointer;
  }
}
.submit-btn {
  border-radius: 28px;
  width: 120px;
}
.roles {
  margin-top: 25px;
}
.resources {
  margin-top: 32px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  border: 1px solid #eceff9;
  border-radius: 8px;
  padding: 12px 20px;
  position: relative;
  .extra-tools {
    position: absolute;
    top: 100%;
    width: 100%;
    left: 0;
    background-color: #fff;
    border: 1px solid #eceff9;
    border-top: 0;
    padding: 0px 11px 11px 11px;
    display: flex;
    justify-content: center;
  }
  .ico {
    cursor: pointer;
  }
  .ico,
  img {
    margin: 0 17px;
  }
  & > div {
    flex-wrap: wrap;
    display: flex;
    align-items: center;
    h6 {
      font-style: normal;
      font-weight: normal;
      font-size: 24px;
      line-height: 33px;
      color: #5b606c;
      margin: 0 10px 0 0;
    }
  }
  .engine {
    margin-top: 3px;
    background-color: rgba(85, 126, 251, 0.1);
    border-radius: 5px;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 5px;
    font-family: "Nunito", sans-serif;
    font-style: normal;
    font-weight: 600;
    font-size: 16px;
    line-height: 22px;
    display: flex;
    align-items: center;
    color: var(--theme-color);
    margin-right: 7px;
    svg {
      margin-left: 5px;
      cursor: pointer;
    }
  }

  h6 {
    font-style: normal;
    font-weight: normal;
    font-size: 24px;
    line-height: 33px;
    display: inline;
    color: #5b606c;
    margin-right: 10px;
    //   margin-bottom: 0;
  }
}
.crew {
  margin-top: 32px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  border: 1px solid #eceff9;
  border-radius: 8px;
  padding: 12px 20px;
  position: relative;
  .extra-crew {
    position: absolute;
    top: 100%;
    width: 100%;
    left: 0;
    background-color: #fff;
    border: 1px solid #eceff9;
    border-top: 0;
    padding: 0px 11px 11px 11px;
    display: flex;
    justify-content: center;
  }
  .ico {
    cursor: pointer;
  }
  .ico,
  img {
    margin: 0 17px;
  }
  & > div {
    flex-wrap: wrap;
    display: flex;
    align-items: center;
    h6 {
      font-style: normal;
      font-weight: normal;
      font-size: 24px;
      line-height: 33px;
      color: #5b606c;
      margin: 0 10px 0 0;
    }
  }
  .engine {
    margin-top: 3px;
    background-color: rgba(85, 126, 251, 0.1);
    border-radius: 5px;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 5px;
    font-family: "Nunito", sans-serif;
    font-style: normal;
    font-weight: 600;
    font-size: 16px;
    line-height: 22px;
    display: flex;
    align-items: center;
    color: var(--theme-color);
    margin-right: 7px;
    svg {
      margin-left: 5px;
      cursor: pointer;
    }
  }

  h6 {
    font-style: normal;
    font-weight: normal;
    font-size: 24px;
    line-height: 33px;
    display: inline;
    color: #5b606c;
    margin-right: 10px;
    //   margin-bottom: 0;
  }
}
.social {
  margin-top: 32px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  border: 1px solid #eceff9;
  border-radius: 8px;
  padding: 12px 20px;
  position: relative;
  .extra-tools {
    position: absolute;
    top: 100%;
    width: 100%;
    left: 0;
    background-color: #fff;
    border: 1px solid #eceff9;
    border-top: 0;
    padding: 0px 11px 11px 11px;
    display: flex;
    justify-content: center;
  }
  .ico {
    cursor: pointer;
  }
  .ico,
  img {
    margin: 0 17px;
  }
  & > div {
    flex-wrap: wrap;
    display: flex;
    align-items: center;
    h6 {
      font-style: normal;
      font-weight: normal;
      font-size: 24px;
      line-height: 33px;
      color: #5b606c;
      margin: 0 10px 0 0;
    }
  }
  .engine {
    margin-top: 3px;
    background-color: rgba(85, 126, 251, 0.1);
    border-radius: 5px;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 5px;
    font-family: "Nunito", sans-serif;
    font-style: normal;
    font-weight: 600;
    font-size: 16px;
    line-height: 22px;
    display: flex;
    align-items: center;
    color: var(--theme-color);
    margin-right: 7px;
    svg {
      margin-left: 5px;
      cursor: pointer;
    }
  }

  h6 {
    font-style: normal;
    font-weight: normal;
    font-size: 24px;
    line-height: 33px;
    display: inline;
    color: #5b606c;
    margin-right: 10px;
    //   margin-bottom: 0;
  }
}
.video-sec {
  margin-left: 15px;
}
.upload-btn {
  cursor: pointer;
  background-color: #fff;
  font-style: normal;
  font-weight: 600;
  font-size: 14px;
  line-height: 19px;
  max-width: 220px;
  height: 50px;
  border: none;
  letter-spacing: 0.05em;
  align-items: center;
  color: var(--theme-color);
  margin-left: 16px;
  border-radius: 4px;
  transition: all 0.2s ease-in-out;
  display: flex;
  justify-content: center;
  align-items: center;
  .content {
    display: flex;
    #blogger-publishing-video {
      width: 0;
    }
    #guide-publishing-image {
      width: 0;
    }
    .ico {
      margin-right: 3px;
      img {
        cursor: pointer;
        position: relative;
        top: 50%;
        right: 4px;
        -webkit-transform: translateY(-50%);
        transform: translateY(-50%);
        height: 24px;
        width: 24px;
        display: -webkit-box;
        display: -ms-flexbox;
        display: flex;
        -webkit-box-align: center;
        -ms-flex-align: center;
        align-items: center;
        -webkit-box-pack: center;
        -ms-flex-pack: center;
        justify-content: center;
        background: rgba(85, 126, 251, 0.1);
        border-radius: 8px;
      }
      svg {
        height: 30px;
      }
    }
    .watch-video {
      margin-top: 5px;
    }
    .btn-content {
      margin-top: 2px;
      font-family: Nunito;
      font-style: normal;
      font-size: 16px;
      line-height: 22px;
      color: var(--theme-color);
    }
  }
}
.upload-btn:focus {
  outline: none;
  box-shadow: none;
}
.description-title {
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 19px;
  color: #8d99a0;
  max-width: 354px;
  width: 100%;
  margin: 18px 0;
  cursor: pointer;
}
.half-fields {
  margin-left: 3px;
}
.fadeHeight-enter-active,
.fadeHeight-leave-active {
  transition: all 0.5s;
  max-height: 230px;
}
.fadeHeight-enter,
.fadeHeight-leave-to {
  opacity: 0;
  max-height: 0px;
  overflow: hidden;
}
</style>
